import script from "./uploadMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadMessage.vue?vue&type=script&setup=true&lang=js"

import "./uploadMessage.vue?vue&type=style&index=0&id=5eef5ff6&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eef5ff6"]])

export default __exports__